"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tenants = void 0;
const generic_entity_1 = require("../../abstracts/generic-entity");
/**
 * A generic Tenants client.
 * Use this to create or list tenants
 */
class Tenants extends generic_entity_1.Entity {
    constructor(parentEntity, debug) {
        super(parentEntity, debug);
    }
    /**
     * This will create a new tenant manually without billing capabilities.
     * Use `tenant.createStripeCheckoutSession()` to ensure the tenant has billing and payments setup
     * @param args `CreateTenantRequestDto`
     * @returns `TenantResponseDto`
     */
    async create(args) {
        return (await this.getHttpClient().post(`/tenant`, args, { headers: this.getHeaders() })).data;
    }
    /**
     * List all tenants in your app
     * @returns a list of `TenantResponseDto`
     */
    async list() {
        return (await this.getHttpClient().get(`/tenant`, { headers: this.getHeaders() })).data;
    }
    /**
     * Creates a Stripe checkout session (for a non existing tenant) and returns the id from which you can render using the Stripe SDK.
     * @param args
     * @returns
     */
    async createStripeCheckoutSession(args) {
        const response = await this.getHttpClient().post(`/app/checkoutId`, args, { headers: this.getHeaders() });
        return response.data;
    }
    async validateImportFromFile(importData) {
        const response = await this.getHttpClient().post(`/import/validateTenantsFromFile`, importData, { headers: this.getHeaders() });
        return response.data;
    }
    async importFromFile(importData) {
        const response = await this.getHttpClient().post(`/import/tenantsFromFile`, importData, { headers: this.getHeaders() });
        return response.data;
    }
    async checkImportStatus(reference) {
        const response = await this.getHttpClient().get(`/import/status/${reference}`, { headers: this.getHeaders() });
        return response.data;
    }
}
exports.Tenants = Tenants;
